import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../../service/seo.service';

@Component({
    selector: 'app-innovazione-ricerca',
    templateUrl: './innovazione-ricerca.component.html',
    standalone: false
})
export class InnovazioneRicercaComponent implements OnInit {

    constructor(private router: Router, private seoService: SeoService) { }

    ngOnInit(): void {
        const h2Text = "Scopri bandi e incentivi per innovazione e ricerca: contributi PNRR, Horizon Europe e legge Patent Box per PMI";
        
        this.seoService.updateSeo({
            titleSeo: "Bandi Innovazione e Ricerca – Finanziamenti PMI | Innovation Plaza",
            metadescription: h2Text
        });
    }

    goTo(route: string){		 
        this.router.navigate([route])
    }
    goBandi(){					
        this.router.navigate(['cerca-bando'])
    }

}